
const ReportsPage: React.FC = () => {
    return (
        <div>ReportsPage</div>
    );
};  

export default ReportsPage;